import * as React from 'react'
import {Link} from "gatsby";

const Overlay = () => {
    return (
        <div className="ort">
            <div className="information">
                <div className="image" id="image">
                    <img alt="" className="ort-img dummy" src={"/images/Logo_ODD.svg"}/>                
                </div>
                <div className="row">
                    <div className="col-12">
                        <h2>
                            Traunreut 
                        </h2>
                    </div>
                </div>
                <p>
Vertriebenenintegration, Würdigung der Integration und des Aufbaus eines kommunalen Gemeinwesens als bedeutendes Ereignis für die Demokratiegeschichte Bayerns nach dem Zweiten Weltkrieg.                </p>
            </div>
                <Link to="/neue-Orte/" className='ort-text icon-arrow-right load-infobox'>
                Mehr erfahren
            </Link>

        </div>
    )
}

export default Overlay

